class FilterPills extends HTMLElement {
  constructor() {
    super();
    this.scrollContainer = this.querySelector('.filter-pills__scroll-container');
    this.scrollHints = this.querySelectorAll('.filter-pills__scroll-hint');
    this.pills = this.querySelectorAll('.filter-pill');
    
    this.init();
  }

  init() {
    // Set up scroll indicators
    if (this.scrollContainer && this.scrollHints.length) {
      this.setupScrollIndicators();
    }
    
    // Add click handlers for filter pills
    this.pills.forEach(pill => {
      if (!pill.classList.contains('filter-pill--clear')) {
        pill.addEventListener('click', this.handleFilterClick.bind(this));
      }
    });
    
    // Listen for filter updates
    document.addEventListener('filter:updated', this.handleFilterUpdate.bind(this));
  }
  
  handleFilterClick(evt) {
    // If active, we're removing the filter, so let default behavior happen
    if (evt.currentTarget.classList.contains('filter-pill--active')) {
      return;
    }
    
    // For adding filters, we can enhance the experience
    evt.preventDefault();
    const pill = evt.currentTarget;
    const url = pill.href;
    
    // Add loading state
    this.classList.add('filter-pills--loading');
    pill.classList.add('filter-pill--loading');
    
    // Update URL and trigger facet filters update if available
    this.updateFilters(url);
  }
  
  updateFilters(url) {
    // Check if facet-filters exists (main filter component)
    const facetFilters = document.querySelector('facet-filters');
    
    if (facetFilters && typeof facetFilters.updateFilters === 'function') {
      // Use the existing filter system
      window.history.pushState({ path: url }, '', url);
      const event = new CustomEvent('popstate', { bubbles: true });
      window.dispatchEvent(event);
    } else {
      // Fallback to page reload
      window.location.href = url;
    }
  }
  
  handleFilterUpdate() {
    // Remove loading states
    this.classList.remove('filter-pills--loading');
    this.querySelectorAll('.filter-pill--loading').forEach(pill => {
      pill.classList.remove('filter-pill--loading');
    });
  }

  setupScrollIndicators() {
    const checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const isScrollable = scrollWidth > clientWidth;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.classList.toggle('filter-pills--scrollable', isScrollable);
      this.classList.toggle('filter-pills--at-start', atStart);
      this.classList.toggle('filter-pills--at-end', atEnd);
    };

    // Check on init and scroll
    checkScroll();
    this.scrollContainer.addEventListener('scroll', debounce(checkScroll, 10));
    
    // Check on resize
    window.addEventListener('resize', debounce(checkScroll, 150));

    // Add click handlers for scroll hints
    const leftHint = this.querySelector('.filter-pills__scroll-hint--left');
    const rightHint = this.querySelector('.filter-pills__scroll-hint--right');

    if (leftHint) {
      leftHint.addEventListener('click', () => {
        this.scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
      });
    }

    if (rightHint) {
      rightHint.addEventListener('click', () => {
        this.scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
      });
    }
  }
}

// Debounce helper
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Initialize when DOM is ready
if (!customElements.get('filter-pills')) {
  customElements.define('filter-pills', FilterPills);
}